"use client";
import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>


      <main className="flex pb-4 w-full bg-[#fff8ef] max-md:p-5 max-sm:p-4">
        <section className="flex-1">
          

          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mt-10 mx-auto text-gray-700 space-y-5">
             <div className="flex items-center justify-center gap-3 mb-8">
             <div
            className=" text-3xl sm:text-3xl md:text-3xl lg:text-4xl 
      font-bold leading-none text-black 
      tracking-[1px] md:tracking-[2px] 
      hover:opacity-80 transition-opacity duration-200 
      flex-shrink-0 min-w-0
      
      lg:[-webkit-text-stroke:2px_gray-700]"
            
            aria-label="Manaprint Home"
          >
            Privacy Policy
          </div>
              </div>
            <p>
              At <strong>Manaprint</strong>, your privacy is important to us. This
              Privacy Policy explains how we collect, use, and protect your
              personal information.
            </p>

            <p>
              <strong>Information we collect:</strong> name, email address,
              phone number, shipping address, uploaded images, and order details.
            </p>

            <p>
              <strong>How we use your data:</strong> to process orders, provide
              customer support, improve our services, and communicate order
              updates.
            </p>

            <p>
              <strong>Data security:</strong> we use secure systems and trusted
              payment gateways to protect your information. We do not sell or
              share your data with third parties except when required for order
              fulfillment.
            </p>

            <p>
              <strong>Cookies:</strong> our website may use cookies to improve
              browsing experience and analyze traffic.
            </p>

            <p>
              <strong>Your rights:</strong> you may request access, correction,
              or deletion of your personal data by contacting us.
            </p>

            <p>
              If you have questions about this policy, contact us at
              <strong> manaprint6@gmail.com</strong>.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
